// extracted by mini-css-extract-plugin
export default {"format-container":"Items_format-container__AdWZa"};